/* eg-magazine.js — scroll reveal observer, single instance per page */
(function(){
  if (window.__egMagInit) return;
  window.__egMagInit = true;

  function init(){
    var els = document.querySelectorAll('.eg-mag-root .reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)){
      els.forEach(function(el){ el.classList.add('is-in'); });
      return;
    }
    var obs = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting){
          e.target.classList.add('is-in');
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -50px 0px' });
    els.forEach(function(el){ obs.observe(el); });
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
